<script lang="ts">
	import type { Product } from "@core/schema/Product.js";
	import CarouselWithArrows from "./CarouselWithArrows.svelte";
	import ProductCard from "./ProductCard.svelte";

	const { crossSaleProducts }: { crossSaleProducts: Product[] } = $props();
</script>

{#if crossSaleProducts.length > 0}
	<CarouselWithArrows
		items={crossSaleProducts}
		itemsContainerClass="*:basis-full lg:*:basis-1/3 *:px-1"
		options={{ slidesToScroll: 1, breakpoints: { 670: { slidesToScroll: 2 }, 1024: { slidesToScroll: 3 } } }}
	>
		{#snippet item(product)}
			<div class="w-full flex justify-center">
				<ProductCard {product} />
			</div>
		{/snippet}
	</CarouselWithArrows>
{/if}
